import openCliJson from 'opencli.json';
import pegaApps from 'pegaApps.json';

import { ApplicationRef } from '@angular/core';

import { OpenCliApplication, OpenCliApplicationParameter, PegaApps, PegaFrontend } from '@ap/pega';

import { StarterAppRetailComponent } from './starter-app-retail.component';

export class StarterAppRetailModuleUtils {
    public static setStarterAppInputs(appRef: ApplicationRef, applicationName = 'pega-starter-app-retail'): void {
        const starterAppRetail = (openCliJson['@devolksbank/webbundle']['applications'] as unknown as OpenCliApplication[]).find(
            (application) => application.name === applicationName
        );
        const retailComponentRef = appRef.components.find((ref) => ref.componentType === StarterAppRetailComponent);
        const frontend = this.getFrontendFromPegaApps();

        if (!frontend || !retailComponentRef) {
            return;
        }

        for (const parameter of starterAppRetail?.parameters || []) {
            const parameterValue = this.getValueForParameter(frontend, parameter);
            if (!parameterValue) {
                continue;
            }

            try {
                retailComponentRef.setInput(parameter.name, parameterValue);
            } catch (error) {
                console.error('Error setting input', error); // NOSONAR
            }
        }
    }

    private static getValueForParameter(frontend: PegaFrontend<string>, parameter: OpenCliApplicationParameter): any {
        return Object.entries(frontend).find(([key]) => key === parameter.name)?.[1];
    }

    private static getFrontendFromPegaApps<T extends string = string>(): PegaFrontend<T> | undefined {
        return (pegaApps as unknown as PegaApps<T>)?.frontends?.find((frontend: PegaFrontend<T>) => {
            return frontend.flavours.find((flavour) => flavour.baseUrl === location.pathname);
        });
    }
}
